module.exports = __webpack_public_path__ + "img/x.22633f11.svg";